import { useEffect, useState } from "react";
import { Users, CreditCard, TrendingUp, Percent, Banknote, CheckCircle2 } from "lucide-react";
import { PageHeader, Spinner, Card } from "@/components/dash";
import api from "@/lib/api";
import { formatTRY } from "@/lib/format";

function Stat({ icon: Icon, label, value }) {
  return (
    <Card className="p-5">
      <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-primary/10 text-primary"><Icon size={18} strokeWidth={1.5} /></span>
      <p className="mt-4 text-2xl font-extrabold tracking-tighter">{value}</p>
      <p className="mt-0.5 text-sm text-muted-foreground">{label}</p>
    </Card>
  );
}

export default function AdminOverview() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then(({ data }) => setS(data)).catch(() => setS({})); }, []);
  if (!s) return <Spinner />;
  return (
    <div>
      <PageHeader title="Yönetici Paneli" desc="Platform genel durumu." />
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
        <Stat icon={Users} label="Merchant Sayısı" value={s.merchants || 0} />
        <Stat icon={CreditCard} label="Toplam Ödeme" value={s.payments || 0} />
        <Stat icon={CheckCircle2} label="Onaylanan" value={s.confirmed || 0} />
        <Stat icon={TrendingUp} label="Toplam Hacim" value={formatTRY(s.total_volume || 0)} />
        <Stat icon={Percent} label="Toplam Komisyon (kripto)" value={(s.total_commission || 0).toFixed(6)} />
        <Stat icon={Banknote} label="Para Çekme Sayısı" value={s.payouts || 0} />
      </div>
    </div>
  );
}
